module.exports = __webpack_public_path__ + "img/Speaker=Michelle Ouellet.d0350886.png";